import { Auth } from 'aws-amplify';
import {
  trackSignUp,
  saveSignUpData,
  getUserAttributes,
  SignUpType,
  updateCompanyWithGetStartedData,
  GET_STARTED_DATA_KEY,
  logger,
} from '.';
import { GetStartedData } from '../Types';
import messages from '../messages';

export const GOOGLE_SIGNIN_KEY = 'google_sign_in';

export const GOOGLE_SIGNUP_ERROR = 'Already found an entry for username';

export const COMPLETED_GOOGLE_SIGNUP_KEY = 'google_sign_up_completed';

interface GoogleSignIn {
  snackbar: {
    show: (msg: string, type: string) => any;
  };
}

export async function googleSignIn({ snackbar }: GoogleSignIn) {
  try {
    await Auth.federatedSignIn({
      provider: 'Google' as any,
    });
    localStorage.setItem(GOOGLE_SIGNIN_KEY, 'true');
  } catch (error) {
    snackbar.show(messages.auth.errors.googleLoginIn, 'error');
    logger.error({
      message: 'google_sign_in',
      error,
    });
  }
}

export async function googleSignInAfterSignUp(
  snackbar: any,
  params: URLSearchParams,
) {
  // SIGNUP WAS SUCCESSFUL BUT NOW USER NEEDS TO SIGN IN
  params.delete('error');
  params.delete('error_description');
  localStorage.setItem(COMPLETED_GOOGLE_SIGNUP_KEY, 'true');
  setTimeout(async () => {
    await googleSignIn({ snackbar });
  }, 750);
}

export async function saveDataAfterGoogleSignUp(
  trackEvent: (event: Record<string, unknown>) => void,
) {
  try {
    await Promise.all([
      handleGetStartedData(),
      saveSignUpData(),
      trackGoogleSignUp(trackEvent),
    ]);
    localStorage.removeItem(COMPLETED_GOOGLE_SIGNUP_KEY);
  } catch (error) {
    logger.error({ message: 'google_save_data_after_signup', error });
  }
}

async function trackGoogleSignUp(trackEvent: (event) => void) {
  const user = await getUserAttributes();
  const userId = user['sub'];
  const email = user['email'];
  const firstName = user['custom:first_name'];
  const lastName = user['custom:last_name'];
  trackSignUp(
    firstName,
    lastName,
    email,
    userId,
    SignUpType.GOOGLE,
    trackEvent,
  );
}

async function handleGetStartedData() {
  try {
    const getStartedData = localStorage.getItem(GET_STARTED_DATA_KEY);
    if (!getStartedData) return;
    const getStartedDataFormatted: GetStartedData = JSON.parse(getStartedData);
    await updateCompanyWithGetStartedData(getStartedDataFormatted);
    localStorage.removeItem(GET_STARTED_DATA_KEY);
  } catch (error) {
    logger.error({ message: 'google_save_get_started_data', error });
  }
}
